"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidatesAnswersViewModel = candidatesAnswersViewModel;
const candidate_answer_1 = require("./candidate-answer");
function candidatesAnswersViewModel(candidatesAnswers) {
    const viewModel = {};
    for (const [candidateId, answers] of Object.entries(candidatesAnswers)) {
        viewModel[candidateId] = answers.map(candidate_answer_1.candidateAnswerViewModel);
    }
    return viewModel;
}
